import React from 'react';
import { Bell, Settings, User } from 'lucide-react';
import { useWalletStore } from '../../store/walletStore';

interface HeaderProps {
  title?: string;
  showProfile?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ title, showProfile = true }) => {
  const { isConnected, address } = useWalletStore();

  return (
    <div className="flex items-center justify-between p-4 bg-white border-b border-gray-100">
      <div className="flex items-center space-x-3">
        {showProfile && (
          <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
            <User size={20} className="text-primary-600" />
          </div>
        )}
        <div>
          {title ? (
            <h1 className="text-xl font-bold text-gray-900">{title}</h1>
          ) : (
            <>
              <p className="text-sm text-gray-500">Welcome back</p>
              <p className="font-semibold text-gray-900">
                {isConnected ? `${address?.slice(0, 8)}...` : 'Connect Wallet'}
              </p>
            </>
          )}
        </div>
      </div>
      
      <div className="flex items-center space-x-3">
        <button className="p-2 rounded-full hover:bg-gray-100 transition-colors">
          <Bell size={20} className="text-gray-600" />
        </button>
        <button className="p-2 rounded-full hover:bg-gray-100 transition-colors">
          <Settings size={20} className="text-gray-600" />
        </button>
      </div>
    </div>
  );
};